module.exports = __webpack_public_path__ + "static/media/_MIC2775.thumbnail.ec632ee1.png";